/**
 * The one password rule (AUTH-5), the same the API applies
 * (`memberfy-api/src/validators/password.validator.js`) wherever a person
 * chooses a password: sign-up, password change and the invite's set-password
 * link. At least 8 characters, with an uppercase letter, a lowercase letter,
 * and a digit. A special character is not required (David, 2026-10-06).
 */
export const MIN_PASSWORD_LENGTH = 8

/** The first rule a password breaks, as a key of the `auth` namespace, or null. */
export function passwordFailureKey(value: string): string | null {
  if (value.length < MIN_PASSWORD_LENGTH) return 'passwordMinLength'
  if (!/[A-Z]/.test(value)) return 'passwordUppercase'
  if (!/[a-z]/.test(value)) return 'passwordLowercase'
  if (!/[0-9]/.test(value)) return 'passwordNumber'
  return null
}
